<div class="bg-yellow-50 border rounded-lg border-amber-200 p-1 flex overflow-hidden align-middle">
  <div class="mr-1 sm:mr-2"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-5 w-5 sm:h-6 sm:w-6 text-yellow-600"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path></svg></div>
 <div class="flex flex-col">
 <div class="text-xs sm:text-sm font-bold text-gray-600">
  Saldo: ${{balance()}}
 </div>
 </div>
 </div>
